import type { Order, SpannedPrice } from '@wix/ambassador-pricing-plans-v2-order/types';
import type { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { getVariantSetupFeeAmount } from '@wix/pricing-plans-utils';
import { usePrice } from '../../../../../hooks';

export function useOrderSummary(plan: Plan, spannedPrices: SpannedPrice[], order: Order | undefined) {
  const variant = plan.pricingVariants?.[0] ?? {};
  const planPrice = {
    value: variant.pricingStrategies?.[0]?.flatRate?.amount ?? undefined,
    currency: plan.currency ?? undefined,
  };
  const price = spannedPrices[0]?.price;
  const setupFee = getVariantSetupFeeAmount(variant);

  const isFreeTrailAvailable = Boolean(!order || order.freeTrialDays);
  const hasFreeTrial = Boolean(variant.freeTrialDays);
  const hasZeroTotal = hasFreeTrial && isFreeTrailAvailable;
  const totalPrice = hasZeroTotal ? '0' : price?.total ?? planPrice.value;

  const { fullPrice: planPriceFormatted } = usePrice({ value: planPrice.value, currency: planPrice.currency });
  const { fullPrice: total } = usePrice({ value: totalPrice, currency: planPrice.currency });
  const { fullPrice: subtotal } = usePrice({ value: price?.subtotal, currency: planPrice.currency });
  const { fullPrice: taxAmount } = usePrice({ value: price?.tax?.amount, currency: planPrice.currency });
  const { fullPrice: setUpFeeFormatted } = usePrice({ value: setupFee, currency: planPrice.currency });

  const amount = price?.coupon?.amount;
  const { fullPrice: couponAmount } = usePrice({
    value: amount ? `-${amount}` : undefined,
    currency: planPrice.currency,
  });

  return { total, subtotal, taxAmount, couponAmount, planPrice: planPriceFormatted, setupFee: setUpFeeFormatted };
}
